import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetByIdArgs } from '../../base/baseGetById.args'

@ArgsType()
export class ArcClaimGetByIdArgs extends BaseGetByIdArgs<ArcClaimGetByIdArgs> {
  @Field(t => Int)
  userId!: number
}
